import { observer } from 'mobx-react-lite'
import { CssBaseline } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'

// Providers
import { useStores, StoreProvider } from './app/providers/withStore'
import { PrevLocationProvider } from './app/providers/PrevLocationProvider'
import AppRouter from './app/routing'
import ThemeProvider from './theme'
import Snackbar from './shared/ui/Snackbar'
import { LazyMotion } from 'framer-motion'
import { customFeatures } from './app/motionFeatures'

// New imports for Localization
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ru } from 'date-fns/locale'

const AppContent = observer(() => {
  const { errorStore } = useStores()

  return (
    <ThemeProvider>
      <CssBaseline />
      <StoreProvider>
        <PrevLocationProvider>
          <AppRouter />
        </PrevLocationProvider>
      </StoreProvider>
      <Snackbar
        open={errorStore.snackbar.open}
        message={errorStore.snackbar.message}
        severity={errorStore.snackbar.severity}
        onClose={() => errorStore.closeSnackbar()}
      />
    </ThemeProvider>
  )
})

const App = () => (
  <LazyMotion features={customFeatures} strict>
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
        <AppContent />
      </LocalizationProvider>
    </BrowserRouter>
  </LazyMotion>
)

export default App
